// extracted by mini-css-extract-plugin
export default {"locker__container":"locker__container--Z8JCy","locker__icon":"locker__icon--tirCd"};